import React, { memo } from "react";
import PropTypes from "prop-types";
import Image from "../Image";
import { defaultOtherProductsData } from "./constants";
import "./OtherProducts.scss";

const OtherProducts = ({ data, heading }) => (
  <div className="other-products p-section-1 !pb-10">
    <div className="container">
      <div
        className="font-heading text-lg md:text-xl"
        style={{ marginBottom: "40px" }}>
        {heading}
      </div>
      <div className="row flex-wrap mobile-wrap items-stretch mx-[-5%] md:mx-[-20px]">
        {(data || defaultOtherProductsData)?.map(
          ({ id, title, body, url, iconname }) => (
            <div className="w-full md:w-1/2 px-5" key={id}>
              <div className="single-other-product !px-6 !py-4 md:!py-6">
                <Image src={iconname} alt={title} width="44" height="44" />
                <div className="other-products-text">
                  <h3 className="font-bold md:font-semibold">{title}</h3>
                  <p className="text-2.5sm">{body}</p>
                  <a
                    href={url}
                    className="anchor-link button button-unstyled btn p-0 !text-cf-green group left-[83px] !right-auto"
                    style={{ display: "inline-flex" }}>
                    Learn More
                    <svg
                      className="!w-[6px] float-left !h-[14px] ml-2.5 group-hover:translate-x-[3px] transition-transform duration-300"
                      width="6"
                      height="11"
                      viewBox="0 0 6 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M1 1L5 5.5L1 10"
                        stroke="#05C16E"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  </div>
);

OtherProducts.defaultProps = {
  data: null,
  heading: "Explore other products",
};

OtherProducts.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      body: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      url: PropTypes.string,
      iconname: PropTypes.string,
    }),
  ),
  heading: PropTypes.string,
};

export default memo(OtherProducts);
